const projects = [
  {
    id: 1,
    title: "Giris Garden ",
    location: "Conoor",
    price: "₹4 Lakhs onwards",
    type: "Plots",
    status: "Available",

    image: "/Images/g4.jpeg",

    description:
      "Gated layout plots with road access and peaceful surroundings. Best for investment and home construction.",

    highlights: [
      "Gated Community",
      "Black Top Roads",
      "Near Main Road",
      "Clear Documents",
      "Ready for Construction"
    ],

    gallery: [
      "/Images/g4.jpeg",
      "/Images/g7.jpeg",
      "/Images/g9.jpeg",
      "/Images/g12.jpeg",
      "/Images/g16.jpeg",
      "/Images/g20.jpeg"
      
    ],

    layout: "/Images/g11.jpeg",

    map: "https://www.google.com/maps?q=Giris%20Garden&output=embed"
  }
];

export default projects;